"use client";

import { useState } from "react";
import GroupFilter from "./Components_temp/GroupFilter";
import ContributorsTable from "./Components_temp/ContributorsTable";
import SubmitPackButton from "./Components_temp/SubmitPackButton";
import { usePackAssignment } from "@/hooks/usePackAssignment";

export default function PackAssignment() {
  const {
    rows,
    groupMode,
    groupCode,
    setGroupMode,
    setGroupCode,
    filteredRows,
    assignNextPack,
    submitPackNumbers
  } = usePackAssignment();

  return (
    <>
      <GroupFilter
        groupMode={groupMode}
        setGroupMode={setGroupMode}
        groupCode={groupCode}
        setGroupCode={setGroupCode}
        rows={rows}
      />

      <ContributorsTable
        rows={filteredRows}
        onAssignPack={assignNextPack}
      />

      <SubmitPackButton
        disabled={!groupMode || !groupCode}
        onSubmit={submitPackNumbers}
      />
    </>
  );
}